var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendsNegative = function SvgTrendsNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.167 11a1 1 0 0 0 1 1H15a1 1 0 0 0 1-1V4.75a1 1 0 1 0-2 0v3.713L8.731 2.818a1 1 0 0 0-1.462 0L5.667 4.534 1.73.318A1 1 0 1 0 .27 1.682l4.667 5a1 1 0 0 0 1.462 0L8 4.966 12.699 10H9.167a1 1 0 0 0-1 1",
    clipRule: "evenodd"
  })));
};
export default SvgTrendsNegative;